import { Component, Input, Output, EventEmitter } from "@angular/core";
import {
  User,
  Notification,
  NotificationListConfig,
} from "../../../../../models";
import { NotificationService } from "../../../../../services";

@Component({
  selector: "general-notification-preview",
  templateUrl: "./general-notification-preview.component.html",
  styleUrls: [
    "./general-notification-preview.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class GeneralNotificationPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../assets/images/uMuzi/african-mask.png";

  @Input() config: NotificationListConfig;
  @Input() notification: Notification;
  @Input() currentUser: User;
  @Output() updateNotifications = new EventEmitter<any>();

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {}

  public markAsRead() {
    this.notificationService
      .updateOne(this.notification.id)
      .subscribe((data) => {
        this.updateNotifications.emit(true);
      });
  }
}
